import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

export function convertISTToLocal(createTimeStamp: string) {
  try {
    // Convert the IST time to UTC
    const timestamp = new Date(createTimeStamp.replace(' ', 'T')).getTime()
    const timestampInUTC = dayjs(timestamp).utcOffset(5.5, true) // Normalize IST to UTC

    // Convert UTC time to the client's local timezone
    const timestampInLocal = timestampInUTC.tz(dayjs.tz.guess())

     return timestampInLocal.format('YYYY-MM-DD HH:mm:ss')
  } catch (error) {
    console.error(error)
  }
}

export function convertUTCToLocal(utcString: string) {
  const localTime = dayjs.utc(utcString).local().format('YYYY-MM-DD HH:mm:ss')
  return localTime
}

 export function formatDateFromUTCString(utcString: string): string {
    const date = new Date(utcString);
    
    const pad = (num: number) => num.toString().padStart(2, '0');
    
    const day = pad(date.getUTCDate());
    const month = pad(date.getUTCMonth() + 1); // Months are zero-based
    const year = date.getUTCFullYear();
    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());
    const seconds = pad(date.getUTCSeconds());
    
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export function getLocalCurrentDate(): string {
  const printedDate:string = dayjs().tz(dayjs.tz.guess()).format("DD/MM/YYYY HH:mm:ss");
  return printedDate;
}